// extracted by mini-css-extract-plugin
module.exports = {"md":"related-menu-item_md_U1XBC","ios":"related-menu-item_ios_Rt-CN","icon":"related-menu-item_icon_26mta"};